import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/app/Logo";
import PodcastSection from "@/components/app/PodcastSection";
import { ArrowLeft, Headphones } from "lucide-react";

export default function PodcastPage() {
  const { user } = useAuth();
  const nav = useNavigate();

  const backTo = user?.id ? "/welcome" : "/";

  return (
    <div className="min-h-screen bg-background" data-testid="podcast-page">
      {/* Slim public header */}
      <header className="border-b border-border bg-card/60 backdrop-blur sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 h-20 flex items-center justify-between">
          <Link to={backTo} data-testid="podcast-page-home-link">
            <Logo size={56} textClassName="text-xl" />
          </Link>
          <nav className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => nav(backTo)}
              data-testid="podcast-page-back"
            >
              <ArrowLeft size={16} className="mr-1.5" />
              {user?.id ? "Back to dashboard" : "Back home"}
            </Button>
          </nav>
        </div>
      </header>

      {/* Title strip */}
      <div className="max-w-6xl mx-auto px-6 sm:px-10 pt-10 sm:pt-14">
        <div className="flex items-center gap-3 text-muted-foreground">
          <Headphones size={18} />
          <p className="text-xs uppercase tracking-[0.22em]">Listen</p>
        </div>
        <h1 className="font-display text-4xl sm:text-6xl font-extrabold tracking-tighter mt-3 text-foreground">
          Poodle People Podcast
        </h1>
        <p className="text-base text-foreground/70 mt-3 max-w-2xl">
          Weekly conversations from Karin and Elise — guests, troubleshooting, and a celebration of the standard
          poodle life. Listen below or subscribe by email so you never miss a new episode.
        </p>
      </div>

      <PodcastSection limit={null} showMoreLink={false} />
    </div>
  );
}
